import { render, staticRenderFns } from "./Ucr.vue?vue&type=template&id=388c04d2&scoped=true&"
import script from "./Ucr.vue?vue&type=script&lang=js&"
export * from "./Ucr.vue?vue&type=script&lang=js&"
import style0 from "./Ucr.vue?vue&type=style&index=0&id=388c04d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c04d2",
  null
  
)

export default component.exports